import { TypePolicies } from '@apollo/client'
import {
    listingDetailTypePolicy,
    listingMatchTypePolicy,
    listingSearchFieldPolicy,
} from './listing.policies'
import {
    projectSearchFieldPolicy,
    projectSearchMatchTypePolicy,
} from './project.policies'
import {
    optionDetailsFieldPolicy,
    optionDetailsTypePolicy,
    propertyTypePolicy,
} from './property.policies'

/*
 * For Reference
 * https://www.apollographql.com/blog/previewing-the-apollo-client-3-cache-565fadd6a01e/
 */

const typePolicies: TypePolicies = {
    /*
     * ROOT_QUERY contains all the fields/queries
     * Add to fields for Pagination, Data Normalization, etc
     */
    Query: {
        fields: {
            ...listingSearchFieldPolicy,
            ...optionDetailsFieldPolicy,
            ...projectSearchFieldPolicy,
        },
    },
    /*
     * Add below the types which have an identifier other than id
     * This is the replacement of dataIdFromObject as it will be deprecated
     * in future versions of @apollo/client
     */
    ...listingDetailTypePolicy,
    ...listingMatchTypePolicy,
    ...propertyTypePolicy,
    ...optionDetailsTypePolicy,
    ...projectSearchMatchTypePolicy,
}

export default typePolicies
